var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button, Grid, IconButton, LinearProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import React from "react";
import { LoadingState } from "../model/models";
const Div_editActionWrapper = styled("div")(({ theme }) => ({
    position: "relative",
}));
const Tooltip_tooltip = styled((_a) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (React.createElement(Tooltip, Object.assign({}, props, { classes: { tooltip: className } }), children));
})(({ theme }) => ({
    fontSize: "1.6rem", //"var(--default-text-font-size)",
    fontFamily: "BrownStd-Regular", //"var(--default-font-family)",
    color: "#fff", //"var(--clr-white)",
    pointerEvents: "auto",
}));
const Button_closeButton = styled(Button)(({ theme }) => ({
    color: "#009fe0", //"var(--clr-secondary)",
    backgroundColor: "#fff", //"var(--clr-white)",
    marginLeft: "auto",
    display: "block",
    fontSize: "1.2rem",
    fontFamily: "BrownStd-Regular", //"var(--default-font-family)",
    "&:hover": {
        color: "#fff", //"var(--clr-white)",
        backgroundColor: "#009fe0", //"var(--clr-secondary)",
    },
}));
export const ActionButton = styled(IconButton)(({ theme, hovercolor }) => ({
    padding: "6px !important",
    borderBottom: "solid 1px #dce0e8 !important", //"solid 1px var(--clr-grey-light-1) !important",
    "& svg": {
        fontSize: "2.4rem",
        color: "#001a37", //"var(--clr-primary)",
    },
    "&:hover svg": {
        color: hovercolor,
    },
    "&:disabled": {
        opacity: "0.5",
    },
}));
const LinearProgress_buttonProgress = styled(LinearProgress)(({ theme }) => ({
    "& .MuiLinearProgress-bar1Indeterminate": {
        backgroundColor: "#009fe0", //"var(--clr-secondary)",
    },
    "& .MuiLinearProgress-bar2Indeterminate": {
        backgroundColor: "#009fe0", //"var(--clr-secondary)",
    },
}));
const style_button_buttonContainer_selected = {
    backgroundColor: "rgba(0, 0, 0, 0.12)",
    borderColor: "gray",
};
const Action = (props) => {
    const toggleActionButtonStyle = () => {
        if (props.action.checked) {
            return style_button_buttonContainer_selected;
        }
        else {
            return null;
        }
    };
    const renderButton = () => {
        if (props.action.toggleAction) {
            const style = toggleActionButtonStyle();
            return (React.createElement("div", null,
                React.createElement(ActionButton, { title: props.action.label, onClick: props.action.onClick, disabled: props.action.disabled, sx: style, hovercolor: props.appModel.theme.primaryColor }, props.action.image)));
        }
        else {
            return (React.createElement(Div_editActionWrapper, null,
                React.createElement(ActionButton, { title: props.action.label, disabled: props.action.disabled, onClick: props.action.onClick, hovercolor: props.appModel.theme.primaryColor }, props.action.image),
                props.action.state == LoadingState.LOADING ? (React.createElement(LinearProgress_buttonProgress, null)) : null));
        }
    };
    const renderTooltipAndButton = () => {
        if (props.action.tooltip) {
            return (React.createElement(Tooltip_tooltip, { open: props.action.tooltip.open, PopperProps: { disablePortal: true }, onClose: props.action.tooltip.onClose
                    ? props.action.tooltip.onClose
                    : () => { }, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, title: React.createElement("div", { style: {
                        maxWidth: props.action.tooltip.maxWidth
                            ? props.action.tooltip.maxWidth
                            : 300,
                    } },
                    props.action.tooltip.label,
                    React.createElement(Button_closeButton, { onClick: props.action.tooltip.onClose
                            ? props.action.tooltip.onClose
                            : () => { } }, props.appModel.i18n("tooltip.understood"))), placement: props.action.tooltip.placement, arrow: true }, renderButton()));
        }
        else {
            return renderButton();
        }
    };
    return React.createElement(Grid, { item: true }, renderTooltipAndButton());
};
export default Action;
